<template>
  <div class="hello">
    <div class="foot">
      <div class="detail_top">
        <div class="detail_left">
          <div class="detail_title" :class="{rea:detail.order_type != paid}">
            <span>{{detail.orderTypeText}}</span>
          </div>
          <div class="detail_time" v-if="detail.order_type == paid">
            <span>订单将在10分钟后取消，请尽快完成付款</span>
          </div>
        </div>
        <div class="detail_right" v-if="detail.order_type ==paid" @click="rePay">
          <span>去支付</span>
        </div>
        <div v-if="detail.order_type ==paid" class="paymentbox" :class="{payment_active:ispayMent}">
          <!-- <div class="pay">
              <div class="weixin_pay">
                <img src="../assets/image/weixin_pay.png" alt="" >
              </div>
              <p>微信支付</p>
          </div> -->
          <div class="pay">
            <a :href="url">
              <div class="weixin_pay">
                <img src="../assets/image/zhifubao.png" alt="">
              </div>
              <p>支付宝</p>
            </a>
          </div>
        </div>
        <!-- delivered  -->
 <!--       <div class="detail_right" v-if="detail.order_type ==delivered">
          <span>提醒发货</span>
        </div> -->
        <div class="detail_right" v-if="detail.order_type != 1 && detail.order_type != 5 && detail.order_type != 0 " style="background:rgba(68,68,68,1);"
          @click="refundEvent()">
          <span>退款</span>
        </div>
        <!-- 已完成 状态 -->
        <div class="detail_right" v-if="detail.order_type ==Completed" style="background:rgba(68,68,68,1);" @click="refundEvent()">
          <span>申请售后</span>
        </div>


        <!-- 待收货 -->
        <div class="detail_right" v-if="detail.order_type ==received" @click="receiving()">
          <span>确认收货</span>
        </div>
        <!-- <div class="detail_right" v-if="detail.order_type ==received " style="background:rgba(68,68,68,1);" @click="refundEvent()">
          <span>退款</span>
        </div> -->
      </div>
	 <div class="detail_logistics" style="padding: 20px 20px; box-sizing: border-box;" v-if="(detail.order_type == 5 || detail.order_type == 3) && expressList.length <= 0 ">
	   <span>查询无结果，请隔段时间再查</span>
	 </div>
      <div class="detail_shop" v-if="(detail.order_type == 5 || detail.order_type == 3)   && expressList.length > 0">
        <span>物流信息</span>
      </div>
	
      <div class="detail_logistics" v-if="(detail.order_type == 5 || detail.order_type == 3)  && expressList.length > 0">
        <div class="detail_body" :class="{btn_active:isShow}">
          <timeline>
            <timeline-item :bg-color="item.color_bg" v-for="(item,index) in expressList" :key="index">
              {{item.context}}
            </timeline-item>
            <!--   <timeline-item :hollow="true">哈哈哈</timeline-item>
            <timeline-item :hollow="true">不给你送了</timeline-item>
            <timeline-item :hollow="true">哈哈哈</timeline-item>
            <timeline-item :hollow="true">不给你送了</timeline-item>
            <timeline-item :hollow="true">哈哈哈</timeline-item>
            <timeline-item :hollow="true">不给你送了</timeline-item>
            <timeline-item :hollow="true">哈哈哈</timeline-item> -->
          </timeline>
        </div>

        <div class="btn_logis" :class="{btn_logis_active:isShow}" @click="open()">
          <span>点击查看更多物流详情</span>
        </div>
      </div>

      <div class="detail_shop">
        <span>商品清单和结算信息</span>
      </div>
      <div class="detail_goods_list">
        <div class="detail_goods_top">
          <div class="detail_odersn">
            <span>订单号：{{detail.ordersn}}</span>
          </div>
          <div class="detail_odersn" v-if="detail.order_type != Cancelled  && detail.order_type != paid ">
            <span>下单时间：{{detail.create_time}}</span>
          </div>
        </div>
        <div class="detail_goodslist" v-for="(item,index) in detail.orderGoods" :key="index">
          <div class="goods_name">
            <div class="goods_pic">
              <img :src="item.spec_pic" alt="">
            </div>
            <div class="detail_spec_title">
              <p>
                {{item.goods_title}}
              </p>
              <p style="color:rgba(0,0,0,0.6);">
                套餐：{{item.spec_name}}
              </p>
              <p style="color: #AF0119;font-size: 16px;">
                {{item.statusText}}
              </p>
            </div>
          </div>
          <div class="goods_number">
            <div class="goods_num">
              <span>{{item.goods_num}}个</span>
            </div>
          </div>
          <div class="goods_number">
            <div class="goods_num">
              <span>{{item.spec_price}}</span>
            </div>
          </div>
        </div>
        <div class="detail_bottom">
          <div class="detail_right_btn">
            <div class="detail_shop_price">
              <span>商品总金额：￥{{all_price}}</span>
            </div>
            <div class="detail_shop_fee">
              <span>运费：￥{{detail.fee_price}}</span>
            </div>
            <div class="detail_shop_fee">
              <span>总计：￥{{detail.all_price}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="detail_message" v-if="detail.orderAddress">
        <div class="detail_message_t">
          <span>订单基本信息</span>
        </div>
        <div class="detail_msg">
          <span>订单号 ：{{detail.ordersn}} </span>
        </div>
        <div class="detail_msg_time">
          <span>下单时间 ：{{detail.create_time}} </span>
        </div>
        <div class="detail_pay_msg">
          <span>支付方式 ：在线支付</span>
        </div>

        <div class="detail_pay_msg">
          <span >收货地址 :{{detail.orderAddress.province + ' ' +  detail.orderAddress.city + ' ' + detail.orderAddress.area + ' ' + detail.orderAddress.detail}}</span>
        </div>

        <div class="detail_msg_time">
          <span>收货人信息 : {{detail.orderAddress.name + ' ' + detail.orderAddress.mobile.substr(0,3) + '*****' + detail.orderAddress.mobile.substr(8)}}</span>
        </div>
        <div class="detail_msg_time">
          <span>配送方式 : {{detail.ship_name ? detail.ship_name : '暂无'}}</span>
        </div>
        <div class="detail_msg_time">
          <span>快递单号 : {{detail.ship_code ? detail.ship_code : "暂无"}}</span>
        </div>
      </div>
      <refund :refundShow="refundShow" @closeEvent="closeEvent()" :orderType="detail.order_type" :goodslist="goodsli"></refund>
      <div style="height: 200px;"></div>
    </div>
  </div>
</template>

<script>
  import {
    Timeline,
    TimelineItem,
    TimelineTitle
  } from 'vue-cute-timeline'
  import refund from '../components/refund.vue'
  export default {
    components: {
      Timeline,
      TimelineItem,
      TimelineTitle,
      refund
    },
    data() {
      return {
        detail: {},
        isShow: false,
        Cancelled: 0,
        paid: 1,
        delivered: 2,
        received: 3,
        Completed: 5,
        refundShow: false,
        logs: [],
        expressList: [],
        ispayMent: false,
        goodsli:[],
        type:1,
        all_price:0,
        order_type:0,
		url:''
      }
    },
    created() {
		let flags = true;
		if(!flags){
			this.url = 'http://shoot.pingyao888.cn/index.php/api/order/alipcpay?order_id=' +this.$route.query.id
		}else{
			this.url = 'https://admin.pipyz.com.cn/index.php/api/order/alipcpay?order_id' + this.$route.query.id
		}
      this.$fetch('order/detail', {
        id: this.$route.query.id
      }).then(res => {
        this.detail = res.data;

        this.detail.orderGoods.forEach(item => {
          this.$set(item, 'isActive', false)
        })
        this.detailShow = true;
        this.detail_type = 2;
       this.all_price = this.detail.orderGoods.reduce((count,item) => count + item.goods_num * parseFloat(item.spec_price),0).toFixed(2);
        if (this.detail.order_type == 3 || this.detail.order_type == 5) {
          this.$fetch('order/express', {
            id: this.$route.query.id
          }).then(res => {
              console.log(res.code)
             if(res.code == '400'){
               this.type = 2;
               this.expressList = [];
             }else{
               this.type = 1;
              if(res.data.data){
				  this.expressList = res.data.data;
				  this.expressList.forEach((item) => {
				      item.isActive = false;
				    })
				    this.expressList[0].isActive = true;
				  
				  this.expressList.forEach(item => {
				    if (item.isActive) {
				      item.color_bg = '#AF011A'
				    } else {
				      item.color_bg = ''
				    }
				  })
			  }
             }





          })
        }
      })
    },
    methods: {
      receiving() {
        this.$fetch('order/confirm', {
          id: this.$route.query.id
        }).then(res => {
          if (res) {
            this.$message.success('收货成功');
            this.$router.push({
              path: '/personal'
            })
          }
        })
      },
      open() {
        this.isShow = true;
      },
      refundEvent() {
        var arr = [];
        this.detail.orderGoods.forEach(item=>{
          if(item.status == 0){
            arr.push(item)
          }
        })
        this.goodsli = arr;
        localStorage.setItem('orderGoods', JSON.stringify(arr));
        this.order_type = this.detail.order_type;
        this.refundShow = true;
      },
      closeEvent(data) {
        this.refundShow = data;
      },
      rePay() {
        this.ispayMent = true;
        setTimeout(() => {
          this.ispayMent = false;
        }, 5000)
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/goodsdetail.css");
</style>



// WEBPACK FOOTER //
// src/pages/goodsdetail.vue